import { AbstractControl, FormGroup } from '@angular/forms';

export class TransponderFormValidator {

  static ValidateVendorType(control: AbstractControl): any {
    let transponderVendor: string = control.get('transponderVendor').value;
    let transponderModel = control.get('transponderModel').value;
    let powerSupplyType9360 = control.get('powerSupplyType9360').value;
    let powerSupplyModel = control.get('powerSupplyModel').value;

    if (transponderVendor !== null && transponderVendor !== undefined && transponderVendor !== '') {
      if ((transponderVendor.toUpperCase() === 'AM COMMUNICATIONS') && (powerSupplyType9360 === undefined || powerSupplyType9360 === '')) {
        control.get('powerSupplyType9360').setErrors({ validatePowerSupply9360: true });
        control.get('powerSupplyModel').updateValueAndValidity({
          onlySelf: true
        })
      } else if (transponderVendor.toUpperCase() !== 'AM COMMUNICATIONS' && (powerSupplyModel === undefined || powerSupplyModel === '')) {
        control.get('powerSupplyModel').setErrors({ validatePowerSupplyModel: true });
        control.get('powerSupplyType9360').updateValueAndValidity({
          onlySelf: true
        })
      }
    } else if (transponderVendor !== 'AM COMMUNICATIONS' || transponderVendor === null || transponderVendor === undefined || transponderModel === '') {
      control.get('powerSupplyModel').setErrors({ validatePowerSupplyModel: true });
      control.get('powerSupplyType9360').updateValueAndValidity({
        onlySelf: true
      })
    }
 
    if (transponderVendor !== null && transponderModel !== null &&  transponderModel !== undefined && transponderModel !== '' && transponderVendor !== undefined && transponderVendor !== '') {
      let transponderModel123 = transponderModel.substring(0, 3);
      if (transponderModel123 == 936 && transponderVendor.toUpperCase() !== 'AM COMMUNICATIONS') {
        control.get('transponderVendor').setErrors({ validateVendorType: true });
      } else if(transponderModel !== 936) {
        control.get('transponderVendor').setErrors(null);
      }
    }
  }
}